import { render, staticRenderFns } from "./One_configuration.vue?vue&type=template&id=f6af9506&"
import script from "./One_configuration.vue?vue&type=script&lang=js&"
export * from "./One_configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports